import { useField } from 'formik';
import ReadonlyFormItem from 'components/new-ui/base/form/ReadonlyFormItem';
import ShipmentIconOutlined from 'components/icons/ShipmentIconOutlined';
import FormSectionHeader from 'components/new-ui/base/form/FormSectionHeader';

const Shipment = () => {
    const fieldName = 'shipment.shipmentId';

    const [field] = useField(fieldName);

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
            <FormSectionHeader title="Shipment" icon={<ShipmentIconOutlined />} />
            <ReadonlyFormItem disabled={true} value={field.value} />
        </div>
    );
};

export default Shipment;
